import { Stack } from "@chakra-ui/react";
import { KYDAdminFeedItem } from "../../../../../common/interfaces/KYDOrganization";
import LinkInput from "./LinkInput";
import ImageUploadInputWithPreview from "./ImageUploadInputWithPreview";

const NewsForm = ({
  loading,
  updateDirtyText,
  dirtyText,
  label,
  feedItem,
}: {
  loading: { link: boolean; tickettype: boolean };
  label: string;
  updateDirtyText: (input: Record<string, any>) => void;
  dirtyText: Record<string, any>;
  feedItem: KYDAdminFeedItem | null;
}) => {
  return (
    <Stack>
      <LinkInput
        updateDirtyText={updateDirtyText}
        feedItem={feedItem}
        valueFrom="title"
        dirtyText={dirtyText}
        label={label}
        isDisabled={loading["link"] || loading["link.preview"]}
      />
      <ImageUploadInputWithPreview
        dirtyText={dirtyText}
        onFileUploadSet={(file) => {
          updateDirtyText({ "item.fileToUpload": file });
        }}
        valueFrom="image"
        feedItem={feedItem}
        isDisabled={loading["link"]}
      />
    </Stack>
  );
};

export default NewsForm;
